<ion-tabs>
  <ion-fab vertical="bottom" horizontal="center" translucent="true">
    <ion-fab-button (click)="goTo('')">
      <ion-icon name="home"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <ion-tab-bar slot="bottom" [ngClass]="{'md': !isIos}">
    <ion-tab-button (click)="goTo('/fibre')" [ngClass]="{'active': isFibre}">
      <ion-icon name="git-network-outline" aria-hidden="true"></ion-icon>
      <ion-label>La fibre dans ma commune</ion-label>
    </ion-tab-button>
    <svg [ngClass]="{'md': !isIos}" height="50" viewBox="0 0 100 50" width="100" xmlns="http://www.w3.org/2000/svg">
      <path d="M100 0v50H0V0c.543 27.153 22.72 49 50 49S99.457 27.153 99.99 0h.01z" 
        fill="red" fill-rule="evenodd" >
      </path>
    </svg>
    <ion-tab-button (click)="goTo('/app')" [ngClass]="{'active': isApp}" class="disabled">
      <ion-icon name="business-outline" aria-hidden="true"></ion-icon>
      <ion-label>Mon application citoyenne</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
  <div class="padding-safe"></div>
</ion-tabs>
